import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { getUsers } from '../../features/admin/adminSlice';
import Loader from '../../components/Loader';

const AllUsers: React.FC = () => {
  const { users, isLoading } = useAppSelector((state) => state.adminData);
  const { profile } = useAppSelector((state) => state.auth);
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getUsers());
  }, [dispatch]);

  useEffect(() => {
    // Check admin access
    if (profile && profile.role !== 'admin') {
      navigate('/login');
    }
  }, [profile, navigate]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 p-3">
      <div className="mx-auto max-w-screen-xl px-4 py-16 lg:flex lg:items-center">
        <div className="mx-auto max-w-xl text-center">
          <h1 className="text-3xl font-extrabold sm:text-5xl text-white">
            Welcome to
            <strong className="font-extrabold text-red-400 sm:block">
              Admin - Users
            </strong>
          </h1>
        </div>
      </div>
      <div className="block w-full overflow-x-auto">
        <table className="items-center bg-gray-800 border border-gray-700 w-full border-collapse rounded-lg">
          <thead>
            <tr>
              <th className="px-6 bg-gray-700 text-gray-300 align-middle border border-solid border-gray-600 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                ID
              </th>
              <th className="px-6 bg-gray-700 text-gray-300 align-middle border border-solid border-gray-600 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                Email
              </th>
              <th className="px-6 bg-gray-700 text-gray-300 align-middle border border-solid border-gray-600 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                Full Name
              </th>
            </tr>
          </thead>

          <tbody>
            {users.map((item) => {
              return (
                <tr key={item.id} className="hover:bg-gray-700 transition-colors">
                  <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left text-gray-300 border-b border-gray-700">
                    {item.id}
                  </td>
                  <td className="border-t-0 px-6 align-center border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-gray-300 border-b border-gray-700">
                    {item.email}
                  </td>
                  <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-gray-300 border-b border-gray-700">
                    <i className="fas fa-arrow-up text-emerald-400 mr-4"></i>
                    {item.firstName + ' ' + item.lastName}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AllUsers;

